const redirect = (e, path, _blank, query = {}) => {
    if (_blank) {
        let routeUrl = e.$router.resolve({
            path: path,
            query: query,
        });
        window.open(routeUrl.href, '_blank');
    } else {
        e.$router.push({ path: path });
    }
};

// 动态加载js
const loadScript = (url, callback) => {
    if (typeof document !== 'undefined') {
        var script = document.createElement('script');
    }
    script.type = 'text/javascript';
    if (typeof callback !== 'undefined') {
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = function () {
                callback();
            };
        }
    }
    script.src = url;
    if (typeof document !== 'undefined') {
        document.head.appendChild(script);
    }
};

const loadStatistics = function () {
    if (typeof document !== 'undefined') {
        var script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.src = 'https://s4.cnzz.com/z_stat.php?id=1280321318&web_id=1280321318';
        var outer = document.createElement('div');
        outer.style.height = '1px';
        outer.style.width = '1px';
        outer.style.overflow = 'hidden';
        outer.appendChild(script1);

        var script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.src = 'https://hm.baidu.com/hm.js?dae78368ac5493c2f47732c49bca8237';

        document.body.append(outer);
        document.body.append(script2);
    }
};

// 设置标题
const setTitle = (title) => {
    let schoolname = localStorage.getItem('schoolname');
    if (schoolname) {
        switch (title) {
            case 'Home':
                title = `${schoolname ? schoolname : ''}`;
                break;
            case '学校概况':
            case '资讯':
                title = `${title}${schoolname ? '-' + schoolname : ''}`;
                break;
            case '资讯查看':
                title = '-' + `${schoolname ? schoolname : ''}`;
                break;
            case '课程查看':
            case '课程播放':
                title = '课程';
                break;
            default:
        }
    }
    if (title) {
        if (title == '首页') {
            title = '全媒体人才培养实训教学平台';
        } else if (title == '思政资源库') {
            title = title + '-教育在线';
        } else if (title.indexOf('党建思政教育资源平台') > -1) {
            title = title + '-杭州职业技术大学';
        }
    } else {
        title = '在线教育学习平台';
    }
    document.title = title;
};
const setFonts = () => {
    var size;
    var winW = window.innerWidth;
    if (winW <= 1600 && winW > 800) {
        size = Math.round(winW / 16);
    } else if (winW <= 800) {
        size = Math.round(winW / 7.5);
        if (size > 65) {
            size = 65;
        }
    } else {
        size = 100;
    }
    document.getElementsByTagName('html')[0].style['font-size'] = size + 'px';
};
const schoolCode = localStorage.getItem('schoolCode');
// localStorage方法
const setUserInfo = (val) => localStorage.setItem('userInfo', JSON.stringify(val));
const getUserInfo = () => {
    return JSON.parse(localStorage.getItem('userInfo'));
};
const removeUserInfo = () => localStorage.removeItem('userInfo');
const clearLocal = () => localStorage.clear();

// 白名单路由不校验登录状态
const whiteList = [
    '/Page404',
    '/Error',
    '/class',
    '/notfound',
    `/${schoolCode}/hzvtc`,
    `/${schoolCode}/hzvtc/list`,
    `/${schoolCode}/hangke/base`,
    `/${schoolCode}/custom/qinghai`,
];

// 需要校验登录状态黑名单路由
const routers = [
    'studyRecord',
    'myClass',
    'myNote',
    'myPractice',
    'myAssess',
    'myPractice/AgainPractice',
    'myPractice/NowPractice',
    'myAssess/assessAnswer',
    'myAssess/againAssess',
    'userMessage',
    'userMessage/bindPhone',
    'userMessage/modifyPhone',
    'userMessage/modifyEmail',
    'updatePassword',
];
const blackList = routers.map((data) => {
    return '/user/' + data;
});

const getUrlSchoolCode = (url) => {
    let code = '';
    if (url) {
        let arr = url.split('/');
        code = arr[2];
    }
    return code;
};

const sdsfdx_code = 100057; // 首都师范大学第二附属中学 （我的课程列表隐藏一级分类）
const qhk12_code = 100072; // 100072 /nologin/class/454 页面隐藏 |信息服务中心，只保留LOGO + 用户信息
// 杭职党建 测试线与正式线id不一致,需要根据环境区分分类id
let hz_mdzjfxId = ''; //  锚定职教方向
let hz_shsmdjkId = ''; //  守护生命的健康
if (process.env.NODE_ENV == 'development') {
    hz_mdzjfxId = '478';
    hz_shsmdjkId = '479';
} else {
    // 第二层判断打包后是测试环境还是正式环境
    if (process.env.VUE_APP_FLAG === 'pro') {
        // 正式环境
        hz_mdzjfxId = '481';
        hz_shsmdjkId = '480';
    } else {
        // 测试环境
        hz_mdzjfxId = '478';
        hz_shsmdjkId = '479';
    }
}

export default {
    blackList,
    whiteList,
    getUrlSchoolCode,
    redirect,
    loadScript,
    setTitle,
    loadStatistics,
    setUserInfo,
    getUserInfo,
    removeUserInfo,
    clearLocal,
    sdsfdx_code,
    setFonts,
    hz_shsmdjkId,
    hz_mdzjfxId,
    qhk12_code,
};
